<app-hero-section>
  @if (darkMode) {
    <picture>
      <source
        media="(min-width: 1024px)"
        srcset="
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_darkmode@1x.avif 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_darkmode@1x.webp 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_darkmode@1x.avif 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_darkmode@1x.webp 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.avif      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.webp      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_darkmode@1x.avif        640w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_darkmode@1x.webp        640w
        "
        sizes="(max-width: 640px) 640px,
                   (max-width: 1024px) 1024px,
                   (max-width: 1440px) 1440px,
                   1920px"
        type="image/avif"
      />
      <img
        class="h-full w-full object-cover"
        src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_darkmode@1x.webp"
        alt="ayr_citizens_greenwarriors"
        fetchpriority="high"
      />
    </picture>
  } @else {
    <picture>
      <source
        media="(min-width: 1024px)"
        srcset="
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_lightmode@1x.avif 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1900_extralargescreen_lightmode@1x.webp 1920w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_lightmode@1x.avif 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1600_extralargescreen_lightmode@1x.webp 1440w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.avif      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.webp      1024w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_lightmode@1x.avif        640w,
          https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_768_smallscreen_lightmode@1x.webp        640w
        "
        sizes="(max-width: 640px) 640px,
                  (max-width: 1024px) 1024px,
                  (max-width: 1440px) 1440px,
                  1920px"
        type="image/avif"
      />
      <img
        class="h-full w-full object-cover"
        src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/warriors/ayr_citizens_greenwarriors_1200_largescreen_lightmode@1x.webp"
        alt="ayr_citizens_greenwarriors"
        fetchpriority="high"
      />
    </picture>
  }
</app-hero-section>
<div
  class="bg-white dark:bg-black text-ayr-black dark:text-white max-w-screen-xl px-6 lg:px-32 py-8 lg:py-16 mx-auto w-full flex flex-col items-start gap-4"
>
  <h1 class="text-47 flex flex-wrap justify-center gap-x-2">
    <span>{{ "frequently-asked-questions_title" | translate }}</span>

    <span class="ayr-underline font-bold">
      {{ "frequently-asked-questions_title_1" | translate }}
    </span>
  </h1>

  <p class="!text-ayr-black dark:!text-white">
    {{ "frequently-asked-questions_presentations" | translate }}
  </p>
  <p class="!text-ayr-black dark:!text-white">
    {{ "frequently-asked-questions_presentations_1" | translate }}
  </p>
  <app-accordion-faq-general-questions />
  <app-accordion-faq-using-app />
  <app-accordion-faq-technical-support />
  <app-accordion-faq-privacy-and-security />
</div>
